export interface FaqContent {
  id: number;
  isVisible: boolean;
  title: string;
  content: string;
  listItems?: string[];
  contentAfterList?: string;
}

export const faqData: FaqContent[] = [
  {
    id: 1,
    isVisible: false,
    title: 'W jaki sposób mogę dołączyć do gierek?',
    content:
      'Wszystkie gierki znajdziesz w sekcji “Gierki”. Możesz je przeglądać w formie listy oraz mapy. Wyrazić chęć dołączenia do gry możesz na 3 sposoby:',
    listItems: [
      'Bezpośrednio na ekranie gry, klikając w przycisk “Dołącz do gierki”',
      'Przez zaproszenie organizatora',
      'Za pomocą linka, który dostaniesz od znajomego'
    ],
    contentAfterList: 'Gdy organizator zatwierdzi Twoje zgłoszenie, gierka pojawi się na Twoim ekranie.'
  },
  {
    id: 2,
    isVisible: false,
    title: 'W jaki sposób mogę zorganizować gierkę?',
    content:
      'Gierkę możesz dodać, klikając w fioletowy przycisk “+” w prawym górnym rogu aplikacji. Podczas tworzenia możesz wybrać, czy chcesz:',
    listItems: [
      'Stworzyć gierkę jednorazowo - wybierz tę opcję, jeśli organizujesz tylko jedną konkretną gierkę i chcesz zebrać skład na dany termin.',
      'Stworzyć gierkę powtarzalną - po zakończeniu jednej gierki aplikacja automatycznie utworzy kolejne wydarzenie na następny tydzień.'
    ]
  },
  {
    id: 3,
    isVisible: false,
    title: 'Gracz nie przyszedł na gierkę, spóźnił się bądź zachowywał się nie w porządku. Co mogę zrobić?',
    content:
      'Organizator może przyznać uczestnikowi ostrzeżenie w formie kartki. Aby to zrobić, wejdź w ekran danej gierki, znajdź wybranego uczestnika i kliknij ikonę trzech kropek po prawej stronie jego profilu. Następnie wybierz odpowiedni typ kartki:',
    listItems: [
      'Żółta kartka - za mniejsze przewinienia, np. spóźnienie, odwołanie udziału w ostatniej chwili lub inne zachowanie wymagające ostrzeżenia.',
      'Czerwona kartka - za poważniejsze przewinienie, np. nieobecność na meczu bez wcześniejszego poinformowania organizatora.'
    ],
    contentAfterList:
      'Przyznane kartki są widoczne w profilu użytkownika, dzięki czemu organizatorzy i uczestnicy mogą łatwiej ocenić jego dotychczasową aktywność i wiarygodność.'
  },
  {
    id: 4,
    isVisible: false,
    title: 'Chciałbym nagrodzić gracza za dobrą grę lub za pomoc drużynie. Co mogę zrobić?',
    content:
      'Przyznawanie komplementów działa podobnie jak w przypadku kartek. Na ekranie gierki wystarczy znaleźć wybranego uczestnika, kliknąć ikonę trzech kropek i wybrać opcję przyznania komplementu. Komplementy są widoczne w profilu użytkownika. Dzięki nim możesz wyróżnić osoby, które były punktualne, grały fair, pomagały w organizacji lub po prostu pozytywnie wpłynęły na atmosferę meczu. W ten sposób wspólnie budujemy pozytywną kulturę i historię Twoich gierek orlikowych.'
  },
  {
    id: 5,
    isVisible: false,
    title: 'W jaki sposób dołączyć do istniejącej grupki?',
    content:
      'Do grupki możesz dołączyć za pośrednictwem organizatora. Po gierce daj znać organizatorowi na miejscu lub przez wiadomość, że chcesz dołączyć do jego grupki. Jeśli organizator prowadzi taką grupkę, będzie mógł dodać Cię do niej, dzięki czemu łatwiej dołączysz do kolejnych gierek i będziesz na bieżąco z nowymi terminami.'
  },
  {
    id: 6,
    isVisible: false,
    title: 'Czy można płacić przez Orlikfy?',
    content:
      'Obecnie płatności można oznaczać w aplikacji ręcznie. Funkcja przyjmowania i zbierania płatności bezpośrednio przez aplikację jest w planach i pracujemy nad jej wdrożeniem.'
  }
];
